import React, { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

// Material ui
import {
    TableRow,
    TableCell,
    Checkbox,
    Grid
} from '@material-ui/core';

// Components
import ContextMenu from '@components/UI-KIT/ContextMenu';

// Types
import {
    CheckColumnWithoutId,
    CheckColumnWithId,
    TableHead,
    GenericItem
} from '@components/UI-KIT/Table';
import { Action } from '@components/UI-KIT/ContextMenu';
import { handleTableContent } from '@components/UI-KIT/Table/ContentHandlers';


interface Props<T extends GenericItem> {
    item: T;
    index: number;
    checkFromTheRight?: CheckColumnWithoutId;
    checkFromTheLeft?: CheckColumnWithoutId;
    checkWithId?: CheckColumnWithId;
    tableHead: TableHead[];
    actions?: Action<T>[]
    hideActions?: (_item: T) => boolean;
    childrenAction: (_item: T) => ReactNode;
}

function GenericTableRow<T extends GenericItem>({
    item,
    index,
    checkFromTheRight,
    checkFromTheLeft,
    checkWithId,
    tableHead,
    actions,
    childrenAction,
    hideActions
}: Props<T>) {
    return (
        <>
            <TableRow
                key={item.id || uuid()}
                className="ui-Table-generic-row"
            >
                {checkFromTheLeft && (
                    <TableCell
                        className="ui-Table-cell"
                    >
                        <Checkbox
                            value={checkFromTheLeft.value}
                            onChange={() => checkFromTheLeft.setValue(index)}
                        />
                    </TableCell>
                )}
                {checkWithId && (
                    <TableCell
                        className="ui-Table-cell"
                    >
                        <Checkbox
                            checked={checkWithId.values.includes(item.id)}
                            onChange={() => checkWithId.setValue(item.id)}
                        />
                    </TableCell>
                )}
                { tableHead.map(head => (
                    <TableCell
                        className="ui-Table-cell"
                        key={uuid()}
                    >
                        {handleTableContent(item, head)}
                    </TableCell>
                ))}
                { checkFromTheRight && (
                    <TableCell
                        className="ui-Table-cell"
                    >
                        <Checkbox
                            value={checkFromTheRight.value}
                            onChange={() => checkFromTheRight.setValue(index)}
                        />
                    </TableCell>
                )}
                { actions && (
                    <TableCell
                        className="ui-Table-cell"
                        align="right"
                    >
                        { (!hideActions || !hideActions(item)) && (
                            <>
                                <Grid
                                    style={{ marginRight: '1rem' }}
                                >
                                    {childrenAction ? childrenAction(item) : ''}
                                    <ContextMenu
                                        item={item}
                                        actions={actions}
                                    />
                                </Grid>
                            </>
                        )}
                    </TableCell>
                )}
            </TableRow>
        </>
    );
};

export default GenericTableRow;
